import { render, staticRenderFns } from "./LicitacaoAtualizacaoAcoesAcessar.vue?vue&type=template&id=73d3d924"
import script from "./LicitacaoAtualizacaoAcoesAcessar.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoAcoesAcessar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports